










































































































































































































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import ListViewItem from "list-view/src/listviewitem";
import NewsModel from "@views/a-model/news-model";
import DefaultModel from "@views/a-model/default-model";
import EnumNewsType from "../../dataSource/api/RunPay/DataModels/Enums/EnumNewsType";
import ControlValidatorGroupComponent from "../components/control-validator-group.vue";
import iMobileDeviceUser from "../a-model/interfaces/iMobileDeviceUser";
import { EnumRoleType } from "../a-model/enum/EnumRoleType";
import PosMarkerData from "../a-model/posMarkerData";
import iKpi from "../a-model/interfaces/iKpi";
import iKpiUser from "../a-model/interfaces/iKpiUser";
import MarkerTemplate from "../components/ui-maps/markerTemplate";
import EnumPosDeviceType from "../../dataSource/api/RunPay/Admin/IServices/Enums/EnumPosDeviceType";
import MapPositionItemResponse from "../../dataSource/api/RunPay/Admin/IServices/Models/Map/MapPositionItemResponse";
import MapEmployeeItemResponse from "../../dataSource/api/RunPay/Admin/IServices/Models/Map/MapEmployeeItemResponse";
import Position from "../components/ui-maps/position";
import Route from "../components/ui-maps/route";
import MapItemResponse from "../../dataSource/api/RunPay/Admin/IServices/Models/Map/MapItemResponse";
import MarkerInfo from "../components/ui-maps/markerInfo";
import ObjectFactory from "../../frameworks/objectFactory";
import {} from "googlemaps";
import WsResponseModel from "../../dataSource/api/SchemaBuilderServer/Models/WsResponseModel";
import ImagePreviewModel from "crop-image/src/ImagePreviewModel";
import ObjectFabric from "../components/objectFabric";

// import EnumStatus from "@dataSource/api/RunPay/Admin/IServices/Enums/EnumStatus";

// enum typesMarker {
//   type1 = "/assets/img/maps/Ellipse.svg",
//   type2 = "/assets/img/maps/Ellipse.png",
//   type3 = "/assets/img/maps/Groupp.svg",
//   type4 = "/assets/img/maps/Group.svg",
//   type5 = "/assets/img/maps/Group7.svg",
//   type6 = "/assets/img/maps/Vector.svg",
//   type7 = "/assets/img/maps/Vector.svg",
//   type8 = "/assets/img/maps/Vector.svg",
// }

// interface mapPoint{
//   Position: MapPositionItemResponse;
// 	Id: number;
// 	Type: EnumPosDeviceType;
// 	Code?: String;
// 	Address?: String;
// 	Phone?: String;
// 	Balance: number;
// 	Employees: Array<MapEmployeeItemResponse>;
// }

enum EnumStatus {
  Success = 0,
  TechnicalProblem = 2,
  NoConnection = 1,
  CashCollection = 3,
  Install = 4,
  NegativeAvailableBalance = 5
}

declare var frontHostUrl: string;

@Component({
  name: "pageMap",
  components: {}
})
export default class PageMapComponent extends Vue {
  key: string = "AIzaSyDX7Cc_IGqQsLRE57xfmGPlGBPDrOD-pd0";
  center: Position = new Position(47.0264, 28.8404);
  mobileUsers: ListViewItem<DefaultModel>[] = [];
  pointsOneCoord: ListViewItem<DefaultModel>[] = [];
  deviceType: ListViewItem<DefaultModel>[] = [];
  deviceStatus: ListViewItem<DefaultModel>[] = [];
  innerItems: PosMarkerData[] = [];
  markersForShow: PosMarkerData[] = [];
  isLoading = false;
  frontMapUrl = frontHostUrl + "/map";
  modalWindowShow = false
   imgCrop: ImagePreviewModel = ObjectFabric.create(ImagePreviewModel, {
      ImageUrl: '',
      Width:0,
      Height:0,
      Top:0,
      Left:0
    })
  countPoint: number[][] = [
    [0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0]
  ];

  @Watch("innerItems")
  onInnerItemsChanged() {
    // console.log("innerItems:", this.innerItems);
    this.markersForShow = this.innerItems.filter(x => x.positionPoint && x.positionPoint.lat && x.positionPoint.lng).map(x => new PosMarkerData(x));
    // console.log("markersForShow:", this.markersForShow);
  }

  full = false; // полный вид легенды
  search = "";
  userId: number = 0;
  deviceId: number = 0;
  searchCodePoint = "";
  imgPath = "/assets/img/maps/";

  info: MarkerInfo = null;

  codePointOneCoord = "";

  created() {
    document.title = this.$route.meta.title;
    this.getMobileUsers("");
    this.getPointsOneCoord("");
    this.getDevicesStatuses();
    this.getDevicesTypes();
    this.getItems();
    this.getStyle();
  }

  // onClickButton(id: number) {
  //   console.log('onClickButton: ', id);
  // }

  onDragEnd(data: { id: number; marker: google.maps.Marker }) {
    const pos = data.marker.getPosition();
    this.currentPosition.lat = pos.lat();
    this.currentPosition.lng = pos.lng();
  }
  closeModalWindow(){
    this.modalWindowShow = false;
  }
  onclick1(){
    console.log("dddd")
    this.$emit('hello')
  }
  onCreateBanner(){
    console.log(this.currentMarker)
    this.$api.ShopService.AddImage
  }
  onMarkerClick(marker: PosMarkerData) {
    // console.log("page-maps: ", marker);
    // когда щелкаем по мареркеру
    // запрашиваем данные для него
    this.$api.MapService.GetPosMarkerDetailsEvent.once(response => {
      if (!response.IsSuccess) {
        return;
      }
      const find = this.markersForShow.find(x => x.id == marker.id);
      if (find) {
        find.fromResponse(response.Value);
      }
      // marker.fromResponse(response.Value);
      // this.$forceUpdate();
      //   var val = response.Value
      //   console.log('this: ', this);

      //   this.info = {
      //     id:val.Id,
      //     // code:val.Code==null||val.Code===undefined?"":val.Code.toString(),\
      //     code:"",
      //     adress:val.Address==null?"":val.Address.toString(),
      //     tel:val.Phone==null?"":val.Phone.toString(),
      //     balans:val.Balance,
      //     employees:val.Employees,
      //     typePoint:this.innerItems.find(el=>el.id==val.Id).typePoint}
      // }
    });
    this.$api.MapService.GetPosMarkerDetails(marker.id);
  }
  initArrayCountPoint() {
    for (let i = 0; i < 2; i++) {
      for (let j = 0; j < 6; j++) {
        this.countPoint[i][j] = 0;
      }
    }
  }

  // onSearchCodePoint() {}

  // onSearchTehnicsRegional() {}

  changeAutocomlite(serchTermit: string) {
    this.getMobileUsers(serchTermit);
  }

  changeAutocomlitePointsOneCoord(serch: string) {
    this.getPointsOneCoord(serch);
  }

  getPointsOneCoord(search: string): Boolean {
    this.$api.MapService.GetPosWithoutPositionEvent.once(response => {
      if (!response.IsSuccess) {
        return false;
      }
      this.pointsOneCoord = [];
      response.Value.forEach(element => {
        this.pointsOneCoord.push(new ListViewItem(new DefaultModel(element.Id, element.Code.toString()), false, false));
      });
    });
    this.$api.MapService.GetPosWithoutPosition({ Search: search });
    return true;
  }

  getMobileUsers(search: string): Boolean {
    this.$api.MapService.GetUsersForMapEvent.once(response => {
      if (!response.IsSuccess) {
        return false;
      }
      this.mobileUsers = [];
      this.mobileUsers.push(new ListViewItem(new DefaultModel(0, this.$locale.getTranslate("allUsers")), false, false));
      response.Value.forEach(element => {
        this.mobileUsers.push(new ListViewItem(new DefaultModel(element.UserId, element.UserName.toString()), false, false));
      });
    });
    this.$api.MapService.GetUsersForMap({ Search: search });
    return true;
  }
  getDevicesStatuses() {
    this.deviceStatus.push(new ListViewItem(new DefaultModel(-1, this.$locale.getTranslate("allStatuses")), false, false));
    for (let i = 0; i <= 5; i++) {
      this.deviceStatus.push(new ListViewItem(new DefaultModel(i, this.$options.filters.terminaleStatusName(i)), false, false));
    }
  }

  getDevicesTypes() {
    this.deviceType.push(new ListViewItem(new DefaultModel(-1, this.$locale.getTranslate("allTypes")), false, false));
    this.deviceType.push(new ListViewItem(new DefaultModel(9, this.$options.filters.terminaleTypeName(9)), false, false));
    this.deviceType.push(new ListViewItem(new DefaultModel(8, this.$options.filters.terminaleTypeName(8)), false, false));
    // for (let i = 1; i <= 10; i++) {
    //   this.deviceType.push(
    //     new ListViewItem(
    //       new DefaultModel(i, this.$options.filters.terminaleTypeName(i)),
    //       false,
    //       false
    //     )
    //   );
    // }
  }

  setFilter() {
    this.getItems();
  }
  pointToAdd: { id: number; code: string };
  // getPointOneCoord(){
  //   if (this.codePointOneCoord=="") return
  //     this.$api.MapService.GetPosWithoutPositionEvent.once(response=>{
  //       if (!response.IsSuccess) {
  //         return;
  //       }
  //       if (response.Value.length==1)
  //       {
  //         this.$dialog.success("Точка найдена. ");
  //         this.pointToAdd.id = response.Value[0].Id
  //         this.pointToAdd.code = response.Value[0].Code.toString();
  //       }

  //     })
  //     this.$api.MapService.GetPosWithoutPosition(this.codePointOneCoord)
  // }
  onChagePointOneCoord(item: ListViewItem<DefaultModel>[]) {
   
    if (item.length == 1) {
      this.pointToAdd = { id: item[0].Value.id, code: item[0].Value.name };
    }
  }

  onGetCoord(coord: { lat: number; lng: number }) {
    if (this.pointToAdd != null) {
      this.$api.MapService.SetPosMapPositionEvent.once(response => {
        if (!response.IsSuccess) {
          return;
        }
        this.getPointsOneCoord("");
        this.getItems();
        this.$dialog.success(this.$locale.getTranslate("deviceCoordinatesAdded"));
        this.pointToAdd = null;
      });

      this.$api.MapService.SetPosMapPosition({
        Id: this.pointToAdd.id,
        Latitude: coord.lat.toString(),
        Longtitude: coord.lng.toString()
      });
    }
  }

  onAddPointToMap() {
    if (this.innerItems.length == 1) {
      /**если есть точка и она одна, добавляем */
      this.$api.MapService.GetPosWithoutPositionEvent;
    }
  }

  clearFilter() {
    this.mobileUsers.forEach(element => {
      element.Selected = false;
    });
    this.deviceType.forEach(element => {
      element.Selected = false;
    });
    this.deviceStatus.forEach(element => {
      element.Selected = false;
    });

    this.searchCodePoint = "";
    this.getItems();
  }

  getIconForPos(item: MapItemResponse): string {
    // debugger
    if (item.Status == null) {
      return ""; // временно
    }
    var prefix = item.Type == EnumPosDeviceType.RunPayMini ? "mini" : "cash";
    var postfix = this.getPosDeviceType(item.Status);
    if (prefix == "mini") this.countPoint[1][item.Status] = this.countPoint[1][item.Status] + 1;
    if (prefix == "cash") this.countPoint[0][item.Status] = this.countPoint[0][item.Status] + 1;
    return `${this.imgPath}${prefix}_${postfix}.svg`;
  }

  getPosDeviceType(id: number): string {
    // debugger
    for (var element in EnumStatus) {
      if (id.toString() == element) {
        return EnumStatus[element];
      }
    }
  }

  currentPosition: { lat: number; lng: number } = { lat: 0, lng: 0 };

  onSaveNewPosition() {
    
  if (this.currentPosition.lng==0&& this.currentPosition.lat==0){
      //если координаты не менялись
      this.currentMarker.draggable = false;
      this.getItems();
    return;
  }
    // console.log("onSaveNewPosition");
    if (this.currentMarker.draggable) {
      this.$api.MapService.SetPosMapPositionEvent.once((res: WsResponseModel<boolean>) => {
        if (res.IsSuccess) {
          this.currentMarker.draggable = false;
          // console.log("res", res);
          this.currentMarker.positionPoint = this.currentPosition;
          // this.$forceUpdate();
          Vue.set(
            this.innerItems,
            this.innerItems.findIndex(x => x.id == this.currentMarker.id),
            this.currentMarker
          );
        }
      });
      this.$api.MapService.SetPosMapPosition({
        Id: this.currentMarker.id,
        Longtitude: this.currentPosition.lng.toString(),
        Latitude: this.currentPosition.lat.toString()
      });
    }
  }

  onClickChangeCoordBtn(event: MouseEvent) {
    
    if (this.currentMarker) {
      this.currentMarker.draggable = !this.currentMarker.draggable;

      const idx = this.innerItems.findIndex(x => x.id == this.currentMarker.id);
      Vue.set(this.innerItems, idx, this.currentMarker);
      this.$nextTick(() => {
        this.$nextTick(() => {
          const btnEl = document.querySelector(`[data-id="${this.currentMarker.id}"] .btn-save-coords`);
          if (!btnEl) {
            console.warn("btnEl не найден!");
            return;
          }
          btnEl.removeEventListener("click", this.onSaveNewPosition);
          btnEl.addEventListener("click", this.onSaveNewPosition);
          // this.$forceUpdate();
        });
      });
      // console.log('draggable: ', self.markersForShow.filter(x=> x.draggable));
    }
  }
  onChangeImg(){
    this.$api.ShopService.AddImageEvent.once(response=>{
      if (!response.IsSuccess) {
         this.isLoading=false;
        this.$notification.error(response.ErrorMessage.toString());
        return
      } 
      this.modalWindowShow = false;
      this.getItems();

    })
    this.isLoading = true;
    this.$api.ShopService.AddImage({PosId:this.currentMarker.id,Image:this.imgCrop })
    
  }

  onClickChangeImgBtn(event: MouseEvent) {
    
    if (this.currentMarker) {
      this.imgCrop.ImageUrl = this.currentMarker.photoUrl!=''?this.currentMarker.photoUrl:'';
      this.modalWindowShow = true;
      // this.currentMarker.draggable = !this.currentMarker.draggable;
     
    }
  }

  currentMarker: PosMarkerData = null;
  onInfoWindowOpened(data: { marker: { id: number; marker: google.maps.Marker } }) {
    const id = data.marker.id;
    const btnEl = document.querySelector(`[data-id="${id}"] .btn-change-coords`);
    const btnChangeImgEl = document.querySelector(`[data-id="${id}"] .btn-change-img`);
    if (!btnEl) {
      console.warn("btnEl не найден!", `[data-id="${id}"] .btn-change-coords`);
      return;
    }
    this.currentMarker = this.markersForShow.find(x => id == x.id);
    const self = this;
    btnChangeImgEl.removeEventListener("click", this.onClickChangeImgBtn);
    btnChangeImgEl.addEventListener("click", this.onClickChangeImgBtn);
    btnEl.removeEventListener("click", this.onClickChangeCoordBtn);
    btnEl.addEventListener("click", this.onClickChangeCoordBtn);
  }

  getItems() {
    this.isLoading = true;
    this.initArrayCountPoint();
    this.$api.MapService.GetPosMarkersEvent.once(response => {
      if (!response.IsSuccess) {
        this.isLoading = false;
        return;
      }

      this.innerItems = [];
      this.innerItems = response.Value.map(el => ({
        id: el.Id,
        positionPoint: {
          lng: el.Position.Longtitude == null ? 0 : parseFloat(el.Position.Longtitude.toString()),
          lat: el.Position.Lattitude == null ? 0 : parseFloat(el.Position.Lattitude.toString())

          // lng:el.Position.Longtitude==null?0:parseInt(el.Position.Longtitude.toString()):this.getRandomInt(100),
          // lat:el.Position.Lattitude!=undefined?parseInt(el.Position.Lattitude.toString()):this.getRandomInt(100)
        },
        icon: this.getIconForPos(el), // typesMarker.type2,
        agentName: el.AgentName,
        typePoint: this.$options.filters.terminaleTypeName(el.Type),
        statusPoint: this.$options.filters.terminaleStatusName(el.Status),
        draggable: false,
        businessHours: el.BusinessHours ? el.BusinessHours.toString() : "",
        photoUrl: el.PhotoUrl ? el.PhotoUrl.toString() : ""
      }));
      this.isLoading = false;
      // this.recalcCenter();
    });
    // debugger

    var selectedUser = this.mobileUsers.filter(item => item.Selected == true);
    var selectedDeviceStatus = this.deviceStatus.filter(item => item.Selected == true);
    var selectedDeviceType = this.deviceType.filter(item => item.Selected == true);
    this.$api.MapService.GetPosMarkers({
      Search: this.searchCodePoint,
      UserId: selectedUser.length > 0 ? (selectedUser[0].Value.name == this.$locale.getTranslate("allUsers") ? null : selectedUser[0].Value.id) : null,
      Status: selectedDeviceStatus.length > 0 && selectedDeviceStatus[0].Value.id >= 0 ? selectedDeviceStatus[0].Value.id : null,
      Type: selectedDeviceType.length > 0 && selectedDeviceType[0].Value.id >= 0 ? selectedDeviceType[0].Value.id : null
    });
  }

  getRandomInt(max: number) {
    return Math.floor(Math.random() * Math.floor(max));
  }

  isValid(): boolean {
    // if(this.fileZip==null && (!this.addingNews===undefined) &&!this.addingNews.folderName.startsWith("http")){
    //   this.zipAlert=true;
    // }

    // if(this.file==null){
    //   this.imageAlert=true;
    // }
    // else this.imageAlert=false
    // return ((this.$refs.validator as ControlValidatorGroupComponent).isValid() && !this.zipAlert && !this.imageAlert);
    return true;
  }
  getStyle(){
        var style: any = {};
    // debugger
    style['height']=300 + "px";
    
    
    console.log("style",style)
    
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/pages/page-map.vue